import React, { useState, useRef, useEffect, memo } from "react";
import {
  OrderFilterMain,
  FilterButton,
  FilterMain,
  SelectFilter,
} from "./styles/OrderFilterStyles";
import SelectDropDown from "../../admin/shared/SelectDropDown";
const OrderFilter = ({
  SetSelectedFilter = () => {},
  SetButtonsFilter = () => {},
  Page = 1,
  setPage = () => {},
}) => {
  const [activeButton, setActiveButton] = useState(0);
  const containerRef = useRef(null);
  const activeButtonRef = useRef(null);

  const handleButtonClick = (index, value) => {
    setActiveButton(index);
    SetButtonsFilter(value);
    if (Page !== 1) {
      setPage(1);
    }
  };

  useEffect(() => {
    scrollToActiveButton();
  }, [activeButton]);

  const scrollToActiveButton = () => {
    if (containerRef.current && activeButtonRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const buttonWidth = activeButtonRef.current.offsetWidth;
      const buttonLeftOffset = activeButtonRef.current.offsetLeft;
      const scrollLeft = buttonLeftOffset - (containerWidth - buttonWidth) / 2;
      containerRef.current.scrollLeft = scrollLeft;
    }
  };

  const ButtonArry = [
    "All",
    "Pending",
    "In Progress",
    "Completed",
    "Cancelled",
  ];

  const options = [
    { value: "this_month", label: "This Month" },
    { value: "last_month", label: "Last Month" },
    { value: "last_thirty_days", label: "Last 30 Days" },
    { value: "last_sixty_days", label: "Last 60 Days" },
    { value: "last_year", label: "This Year" },
    // { value: "Maximum", label: "Maximum" },
    // { value: "Custom", label: "Custom" },
  ];
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    SetSelectedFilter(selectedOption);
    // Perform any desired actions with the selected option
    if (Page !== 1) {
      setPage(1);
    }
  };

  return (
    <>
      <FilterMain>
        <OrderFilterMain ref={containerRef}>
          {ButtonArry.map((value, index) => {
            return (
              <FilterButton
                ref={index === activeButton ? activeButtonRef : null}
                className={index === activeButton ? "active" : ""}
                onClick={() => handleButtonClick(index, value)}
                key={index}
              >
                {value}
              </FilterButton>
            );
          })}
        </OrderFilterMain>
        <SelectFilter>
          <SelectDropDown
            options={options}
            selectedOption={selectedOption}
            handleChange={handleChange}
            placeholder="Filter"
            Height={38}
            BorderRadius={false}
          />
        </SelectFilter>
      </FilterMain>
    </>
  );
};

export default memo(OrderFilter);
